<section>
    <div class="modal-header">
        <button mat-icon-button (click)="closeDialog()" style="position: absolute; right: 10px;">
            <mat-icon>close</mat-icon>
        </button>
        <h2>Agregar Operacion</h2>
    </div>
    <div class="modal-body">
        <section *ngIf="loadingOperations" style="display: flex; justify-content: center;">
            <mat-spinner diameter="70"></mat-spinner>
        </section>    
        <section>
            <div [hidden]="dataSource.data.length == 0">
                <div class="overflow-table">            
                    <table mat-table matSort [dataSource]="dataSource">

                        <ng-container matColumnDef="selection">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let element">
                                <mat-checkbox (click)="$event.stopPropagation()"
                                    (change)="$event ? operationsToAdd.toggle(element): null" 
                                    [checked]="operationsToAdd.isSelected(element)">
                                </mat-checkbox>                    
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="folio">
                            <th class="th-header" mat-header-cell *matHeaderCellDef>
                                Folio
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <h6>{{element.folio}}</h6>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="downPaymentPercentage">
                            <th class="th-header" mat-header-cell *matHeaderCellDef>
                                % Pago Inicial
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <h6>{{element.downPaymentPercentage | number}}</h6>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="financedAmount">
                            <th class="th-header" mat-header-cell *matHeaderCellDef>
                                Financiado
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <h6>{{element.financedAmount | currency:'CLP'}}</h6>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="transferAmount">
                            <th class="th-header" mat-header-cell *matHeaderCellDef>
                                Transferencia
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <h6>{{element.transferAmount | currency:'CLP'}}</h6>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="allInRate">
                            <th class="th-header" mat-header-cell *matHeaderCellDef>
                                Tasa Total
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <h6>{{element.allInRate | number}}</h6>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="rate">
                            <th class="th-header" mat-header-cell *matHeaderCellDef>
                                Tasa
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <h6>{{element.rate | number}}</h6>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="plazo">
                            <th class="th-header" mat-header-cell *matHeaderCellDef>
                                Plazo
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <h6>{{element.plazo}}</h6>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="createdAt">
                            <th class="th-header" mat-header-cell *matHeaderCellDef>
                                Creado
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <h6>{{element.createdAt | date: 'dd-MM-yyyy'}}</h6>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="columns"></tr>
                        <tr mat-row *matRowDef="let row; columns: columns"></tr>
                    </table>
                </div>
                <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
            </div>

            <span class="no-content" *ngIf="dataSource.data.length == 0 && !loadingOperations">
                <h3>No hay operaciones para agregar a la Minuta</h3>
            </span>

            <div class="actions-btn">
                <button (click)="addOperations()" [disabled]="operationsToAdd.selected.length === 0" mat-raised-button color="primary">Agregar a Minuta</button>
            </div>
        </section>
    </div>
</section>